import { IPoint } from '@sparelabs/geography'
import { IListModelQueryParamValues } from '@sparelabs/http-client-utils'

export enum TurnRuleAction {
  Allow = 'allow',
  Forbid = 'forbid',
}

export interface ITurnRulePostBody {
  fromOsmWayId: string
  viaOsmNodeId: string
  toOsmWayId: string
  fromBearing: number
  viaLocation: IPoint
  toBearing: number
  action: TurnRuleAction
}

export interface ITurnRulePatchBody extends Partial<ITurnRulePostBody> {}

export interface ITurnRuleResponse extends ITurnRulePostBody {
  id: string
  createdAt: number
  updatedAt: number
}

export interface IListTurnRuleQueryParams extends IListModelQueryParamValues {}
